import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import { createModel, type MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const ROLES = {
    berechnungsgrundlagen_allgemein: 'berechnungsgrundlagen_allgemein',
    berechnungsgrundlagen_gebaeude: 'berechnungsgrundlagen_gebaeude',
    berechnungsgrundlagen_produktion: 'berechnungsgrundlagen_produktion',
    berechnungsgrundlagen_jahreswerte: 'berechnungsgrundlagen_jahreswerte',
    datenimport: 'datenimport',
    berechnungen: 'berechnungen',
    auswertungen: 'auswertungen',
    systemeinstellungen: 'systemeinstellungen',
    bemerkung: 'bemerkung',
};

export class WaermeerzeugerHeizung extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    bezeichnung: string | null = null;
    reihenfolge: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'WaermeerzeugerHeizung';
    }
}

export async function createNewWaermeerzeugerHeizung(): Promise<WaermeerzeugerHeizung> {
    const model = createModel(WaermeerzeugerHeizung, {});

    await model.save();
    return model;
}

export class WaermeerzeugerHeizungCollection extends BaseCollection<WaermeerzeugerHeizung> {
    protected modelCls = WaermeerzeugerHeizung;

    public getModelClassName(): string {
        return 'WaermeerzeugerHeizung';
    }
}